import i18next from "config/i18next";
import moment from "moment";
import { ProofType } from "../sagas/types/detailTransactions";

const formatTimestamp = (value?: Date): string =>
  value != null
    ? moment(value).format("DD/MM/YYYY HH:mm:ss")
    : moment().format("DD/MM/YYYY HH:mm:ss");

export const watermarkImageWithText = (
  originalImage: HTMLImageElement,
  watermarkText: string,
  type: ProofType,
  hasCoords: boolean = true,
  timestamp?: Date
) => {
  const timestampLabel = () => formatTimestamp(timestamp);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const orientation =
    originalImage.width > originalImage.height ? "horizontal" : "vertical";

  const calcHeigth = () => {
    if (type === "sign") return 800;
    if (orientation === "horizontal" && originalImage.height < 800) return 800;
    if (orientation === "vertical" && originalImage.height < 1200)
      return 1200;
    return originalImage.height;
  };
  const calcWidth = () => {
    if (type === "sign") return 600;
    if (orientation === "horizontal" && originalImage.width < 1200) return 1200;
    if (orientation === "vertical" && originalImage.height < 800) return 800;
    return originalImage.width;
  };
  if (context) {
    const canvasWidth = calcWidth();
    const canvasHeight = calcHeigth();

    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    if (type === "sign") {
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, canvasWidth, canvasHeight);
    }
    context.drawImage(originalImage, 0, 0, canvasWidth, canvasHeight);
    let diagonalLength = Math.sqrt(
      canvas.width * canvas.width + canvas.height * canvas.height
    );
    let diagonalSlope = canvas.height / canvas.width;
    const addDiagonalText = (
      ctx: CanvasRenderingContext2D,
      text: string,
      textColor: string
    ) => {
      ctx.save();
      ctx.fillStyle = textColor;
      ctx.font = `1000 ${diagonalLength / 10}px Mulish`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";

      let centerX = canvas.width / 2;
      let centerY = canvas.height / 2;

      ctx.translate(centerX, centerY);
      ctx.rotate(-Math.atan(diagonalSlope));

      ctx.fillText(text, 0, 0);

      ctx.restore();
    };

    const drawWaterMark = (
      ctx: CanvasRenderingContext2D,
      x: number,
      y: number,
      width: number,
      height: number,
      radius: number,
      color: string,
      text: string,
      textColor: string
    ) => {
      const offset = type === "sign" ? height * 0.3 : height * 0.2;
      const fontSize = type === "sign" ? height * 0.2 : height * 0.12;
      const lineHeight = type === "sign" ? height * 0.24 : height * 0.18;
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.arcTo(x + width, y, x + width, y + radius, radius);
      ctx.arcTo(x + width, y + height, x + width - radius, y + height, radius);
      ctx.arcTo(x, y + height, x, y + height - radius, radius);
      ctx.arcTo(x, y, x + radius, y, radius);
      ctx.closePath();

      ctx.strokeStyle = color;
      ctx.stroke();

      ctx.fillStyle = color;
      ctx.fill();

      ctx.fillStyle = textColor;
      ctx.font = `${fontSize}px Mulish`;
      ctx.textAlign = "start";
      ctx.textBaseline = "middle";
      const splitedText = text.split("\n");
      // eslint-disable-next-line array-callback-return
      splitedText.map((text, index) => {
        if (ctx.measureText(text).width < width) {
          if (type === "sign" && index !== 3)
            ctx.fillText(text, x + offset, y + lineHeight * index + offset);
          else ctx.fillText(text, x + offset, y + lineHeight * index + offset);
        }
      });
      addDiagonalText(
        context,
        i18next.t("detailTransaction:confidential"),
        type === "sign" ? "rgba(16, 24, 32, 0.35)" : "rgba(255,255,255,0.44)"
      );
    };

    const showWatermarkBox = true;
    if (showWatermarkBox) {
      const backgroundHeight = canvasHeight * 0.1;
      const padding = 30;
      const waterMarkHeight = backgroundHeight - padding;
      const bottomMargin = 50;
      const waterMarkYPosition = canvasHeight - backgroundHeight - bottomMargin;
      const textWithTimestamp = [timestampLabel(), watermarkText]
        .filter(Boolean)
        .join("\n");
      drawWaterMark(
        context,
        padding,
        type === "sign" ? waterMarkYPosition - 20 : waterMarkYPosition,
        canvasWidth - padding * 2,
        type === "sign"
          ? waterMarkHeight * 2 + 20
          : orientation === "horizontal"
          ? waterMarkHeight * 2
          : waterMarkHeight,
        10,
        "rgba(0,0,0,0.5)",
        textWithTimestamp,
        "white"
      );
    } else {
      addDiagonalText(
        context,
        i18next.t("detailTransaction:confidential"),
        "rgba(16, 24, 32, 0.35)"
      );
    }
  }
  return canvas.toDataURL();
};
